import { generatePath } from '@ps/web-core-utils';

export const generateSportsPath = (
  route: string,
  values?: Record<string, string | number | boolean | undefined>
): string => {
  const formattedMarketId =
    values?.marketId && typeof values.marketId === 'string'
      ? values.marketId.replace('.', '-')
      : undefined;

  return generatePath(route, {
    ...values,
    ...(formattedMarketId && { marketId: formattedMarketId })
  });
};
